// extracted by mini-css-extract-plugin
export default {"tabContainer":"hoverTab_tabContainer__o27TX","btn":"hoverTab_btn__x3QH1","dropdownMenu":"hoverTab_dropdownMenu__3sYwV","dropdown-menu":"hoverTab_dropdown-menu__vS-z8"};